import apiClient from "./axios-client";

/**
 * get print receipt details
 * @returns
 */
export const getUserZoneList = async () => {
  const response = await apiClient.get(`/zone/getZoneByProfile`);
  return response.data;
};

export const cashChallanResult = async (body) => {
  const response = await apiClient.post(`/receipt/view-cash-chalan`, body);
  return response.data;
}

export const chequeDdChallanResult = async(body) => {
  const response = await apiClient.post(`/receipt/view-chequedd-chalan`,body);
  return response.data;
}